export default __webpack_public_path__ + "static/media/40D47F9E28414EE0AB2CDCA76821AB56.712d722a.png";